import React from 'react'
import { Link } from 'react-router-dom';

export default function MovieItem({ item }) {
  return (
    <div className="col-lg-3 col-md-4 col-sm-6 mb-4">
      <div className="card h-100 shadow-sm">
        <div className="d-flex align-items-center justify-content-center bg-light" style={{ height: "220px" }}>
          <img src={item.Poster} alt={item.Title} style={{maxHeight: "100%", maxWidth: "100%", objectFit: "contain"}}/>
        </div>
        <div className="card-body d-flex flex-column">
          <h5 className="card-title mb-2" style={{display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden", minHeight: "3em"}}>
            {item.Title}
          </h5>
          <div className="text-muted small">
            Year: {item.Year}
          </div>
          <div className="text-muted small mb-3">
            Type: {item.Type}
          </div>
          <Link to={"/Movies/" + item.imdbID} className="btn btn-dark mt-auto w-100"> More info </Link>
        </div>
      </div>
    </div>
  )
}